const Slider = () => {
  const swiperWrapper = document.querySelectorAll(".swiper");

  if (swiperWrapper) {
    swiperWrapper.forEach((s) => {
      const id = s.dataset.id;
      const disabledMobile = s.dataset.disabledmobile;

      if (isMobile && disabledMobile === "true") return;

      let opt = {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };

      if (id === "map-overview") {
        opt = {
          effect: "fade",
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        };
      }

      const slider = new Swiper(s, opt);

      // For map navigation
      if (id === "map-overview") {
        mapSliderOverview = slider;
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  Slider();
});
